import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from '../../../core/api.service';
import { BaseApiOutput, TransferItemDownload, TransferItemUpload } from '../../models';

@Component({
  selector: 'app-save-file',
  templateUrl: './save-file.component.html',
})
export class SaveFileComponent implements OnChanges {
  @Input() public saveFile: TransferItemDownload | TransferItemUpload;
  @Input() public autodownload: number;

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['saveFile'] &&
      changes['saveFile'].currentValue &&
      this.autodownload &&
      !this.saveFile.renderFile.downloadSuccess
    ) {
      setTimeout(() => {
        const elem = document.getElementById(this.saveFile.uniqid);
        if (elem) {
          elem.click();
          // Set 'downloadSuccess' to 1 to indicate that the download has been triggered successfully
          this.saveFile.renderFile.downloadSuccess = 1;
        }
      }, 1000);
    }
  }

  public bypassSecurityTrustUrl(url): SafeUrl {
    if (url) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return null;
  }

  public msBlobSave(blob: Blob, filename: string): void {
    if (this.saveFile.linkID) {
      this.consume([this.saveFile.linkID]);
    }
    const backupCodeFile: string = window.URL.createObjectURL(blob);
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      //save file for IE
      (window.navigator as any).msSaveOrOpenBlob(blob, filename);
    } else {
      //save for other browsers: Chrome, Firefox
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = backupCodeFile;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  public saveDlAttr(): void {
    if (this.saveFile.linkID) {
      this.consume([this.saveFile.linkID]);
    }
  }

  public consume(links: Array<string>): Promise<BaseApiOutput> {
    const publinks = [];
    for (let i = 0, len = links.length; i < len; i++) {
      publinks.push({ publink_id: links[i] });
    }
    return this.apiService.execute('linkconsume', { links: publinks });
  }
}
